import type { WeComApp, WeComAppRequest } from "@/entities/wecom-app";

/**
 * 统一配置:一租户一行,module 固定 customer_service(承载 KF),identityMode 决定是否启用军师工作台。
 * 默认 TENANT_CHAIN(新建即开军师三脸;可在能力区关掉退回纯客服)。
 */
export function emptyAppForm(): WeComAppRequest {
  return {
    corpId: "",
    agentId: null,
    appSecret: "",
    callbackToken: "",
    encodingAesKey: "",
    label: "",
    enabled: true,
    module: "customer_service",
    callbackDomain: "",
    companyName: null,
    identityMode: "TENANT_CHAIN",
  };
}

/** 军师工作台是否启用 = identityMode 为 TENANT_CHAIN。 */
export function isAdvisorEnabled(app: Pick<WeComApp, "identityMode"> | null | undefined): boolean {
  return app?.identityMode === "TENANT_CHAIN";
}

export function activeAppLabel(apps: WeComApp[], appId: number | null): string | null {
  if (!appId) return null;
  const a = apps.find((x) => x.id === appId);
  if (!a) return null;
  return a.label || a.corpId;
}
